'use client';

import React from 'react';
import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { Theme } from '@mui/material/styles';
import SubmitButton from '../SubmitButton';

export type FooterProps = {
  footerHelperText?: string | React.ReactNode;
  onNext?: () => void;
  onNextText?: string;
  nextDisabled?: boolean;
  onPrev?: () => void;
  onPrevText?: string;
};

const MobileFooter = ({
  onNext,
  onNextText,
  onPrev,
  onPrevText,
  footerHelperText,
  nextDisabled,
}: FooterProps) => (
  <Stack flexDirection="column" alignItems="center" width="100%" mt={2} mb={2} pl={0.5} pr={0.5}>
    {footerHelperText && (
      <Stack flex={1} width="100%" mt={2} alignItems="center" justifyContent="center">
        {footerHelperText}
      </Stack>
    )}
    <Stack
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      flex={1}
      width="100%"
      mt={2}
    >
      {onPrev && (
        <Button variant="outlined" onClick={onPrev} style={{ flexGrow: 1 }}>
          {onPrevText || 'Back'}
        </Button>
      )}
      {onPrev && (onNext || onNextText) && <Box width="12px" />}
      {(onNext || onNextText) && (
        <SubmitButton
          variant="contained"
          onClick={onNext}
          data-testid="button-submitNext"
          disabled={nextDisabled}
          style={{ flexGrow: 1 }}
        >
          {onNextText || 'Next'}
        </SubmitButton>
      )}
    </Stack>
  </Stack>
);

const DesktopFooter = ({
  onNext,
  onNextText,
  onPrev,
  onPrevText,
  footerHelperText,
  nextDisabled,
}: FooterProps) => (
  <Stack
    flexDirection="row"
    justifyContent="flex-end"
    alignItems="center"
    height="100px"
    width="100%"
    maxWidth={600}
    mx="auto"
  >
    {footerHelperText && (
      <Stack flex={1} width="100%" mt={2}>
        {footerHelperText}
      </Stack>
    )}
    <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" flex={1} width="100%">
      {onPrev && (
        <Button variant="outlined" onClick={onPrev} style={{ cursor: 'pointer' }}>
          {onPrevText || 'Back'}
        </Button>
      )}
      {onPrev && (onNext || onNextText) && <Box width="12px" />}
      {(onNext || onNextText) && (
        <SubmitButton
          variant="contained"
          onClick={onNext}
          data-testid="button-submitNext"
          disabled={nextDisabled}
        >
          {onNextText || 'Next'}
        </SubmitButton>
      )}
    </Stack>
  </Stack>
);

const Footer = (props: FooterProps) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.only('mobile'));

  return (
    <Stack
      position="sticky"
      bottom="0"
      borderTop="1px solid"
      borderColor="surface.light"
      bgcolor="white"
      zIndex={1}
      alignItems={{
        mobile: 'center',
        signupLayout: 'flex-start',
      }}
      px={{
        mobile: 2,
        signupLayout: 4,
      }}
    >
      {isMobile ? <MobileFooter {...props} /> : <DesktopFooter {...props} />}
    </Stack>
  );
};

export default Footer;
